import React from 'react';
import {FormattedMessage} from 'react-intl';
import defaultDocument from '../assets/defaultDocument.svg';
import {documentTypes as T} from '../constants/documentTypes';
import PopupCreateDocument from '../components/PopupCreateDocument';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';

const getData = (doc) => {
  switch (doc) {
    case T.WORK_ORDER:
      return {
        icon: '/media/common/Order_red.svg',
        color: 'error',
        title: 'הזמנת עבודה'
      };
    case T.INVOICE:
      return {
        icon: '/media/common/Invoice_warning.svg',
        color: 'warning',
        title: 'חשבונית מס'
      };
    case T.INVOICE_RECEIPT:
      return {
        icon: '/media/common/Invoice-receipt_navy.svg',
        color: 'navy',
        title: 'חשבונית מס / קבלה'
      };
    case T.RECEIPT:
      return {
        icon: '/media/common/Receipt_secondary.svg',
        color: 'secondary',
        title: 'קבלה'
      };
    default:
      return {
        icon: '/media/common/Create-doc-from.svg',
        color: '',
        title: ''
      };
  }
};

export const getDocumentTypeData = (type, id) => {
  switch (type) {
    case T.PRICE_QUOTE:
      return {
        icon: <img src={toAbsoluteUrl('/media/common/Price_quote_green.svg')} alt="icon"/>,
        badgeColor: 'success',
        backgroundColor: 'bg-success',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-10"
            defaultMessage="Price"
          />,
        createFromDocumentItemsList: [T.WORK_ORDER, T.INVOICE, T.INVOICE_RECEIPT].map(item => {
          return (
            <PopupCreateDocument
              buttonVariant={'icon'}
              iconButtonType={getData(item).color}
              buttonIcon={<img src={toAbsoluteUrl(getData(item).icon)} className={'w-20px h-20px'} alt="icon"/>}
              documentType={item}
              documentId={id}
              withCopiedData={true}
              title={getData(item).title}
            />
          );
        })
      };
    case T.WORK_ORDER:
      return {
        icon: <img src={toAbsoluteUrl('/media/common/Order_red.svg')} alt="icon"/>,
        badgeColor: 'primary',
        backgroundColor: 'bg-primary',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-100"
            defaultMessage="Work order"
          />,
        createFromDocumentItemsList: [T.INVOICE, T.INVOICE_RECEIPT].map(item => {
          return (
            <PopupCreateDocument
              buttonVariant={'icon'}
              iconButtonType={getData(item).color}
              buttonIcon={<img src={toAbsoluteUrl(getData(item).icon)} className={'w-20px h-20px'} alt="icon"/>}
              documentType={item}
              documentId={id}
              withCopiedData={true}
              title={getData(item).title}
            />
          );
        })
      };
    case T.RETURN_CERTIFICATE:
      return {
        icon: <img src={defaultDocument} alt="icon"/>,
        badgeColor: 'secondary',
        backgroundColor: 'bg-secondary',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-210"
            defaultMessage="Return certificate"
          />,
        createFromDocumentItemsList: []
      };
    case T.TRANSACTION_ACCOUNT:
      return {
        icon: <img src={toAbsoluteUrl('/media/common/Transaction-account_primary.svg')} alt="icon"/>,
        badgeColor: 'info',
        backgroundColor: 'bg-info',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-300"
            defaultMessage="Transaction account"
          />,
        createFromDocumentItemsList: []
      };
    case T.INVOICE:
      return {
        icon: <img src={toAbsoluteUrl('/media/common/Invoice_warning.svg')} alt="icon"/>,
        badgeColor: 'warning',
        backgroundColor: 'bg-warning',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-305"
            defaultMessage="Invoice"
          />,
        createFromDocumentItemsList: [T.RECEIPT].map(item => (
            <PopupCreateDocument
              buttonVariant={'icon'}
              iconButtonType={getData(item).color}
              buttonIcon={<img src={toAbsoluteUrl(getData(item).icon)} className={'w-20px h-20px'} alt="icon"/>}
              documentType={item}
              documentId={id}
              withCopiedData={true}
              title={getData(item).title}
            />
          )
        )
      };
    case T.INVOICE_RECEIPT:
      return {
        icon: <img src={toAbsoluteUrl('/media/common/Invoice-receipt_navy.svg')} alt="icon"/>,
        badgeColor: 'dark',
        backgroundColor: 'bg-dark',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-320"
            defaultMessage="Tax"
          />,
        createFromDocumentItemsList: []
      };
    case T.CREDIT_INVOICE:
      return {
        icon: <img src={defaultDocument} alt="icon"/>,
        badgeColor: 'secondary',
        backgroundColor: 'bg-secondary',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-330"
            defaultMessage="Credit invoice"
          />,
        createFromDocumentItemsList: []
      };
    case T.RECEIPT:
      return {
        icon: <img src={toAbsoluteUrl('/media/common/Receipt_secondary.svg')} alt="icon"/>,
        badgeColor: 'danger',
        backgroundColor: 'bg-danger',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-400"
            defaultMessage="Receipt"
          />,
        createFromDocumentItemsList: []
      };
    case T.DONATION_RECEIPT:
      return {
        icon: <img src={defaultDocument} alt="icon"/>,
        badgeColor: 'secondary',
        backgroundColor: 'bg-secondary',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-405"
            defaultMessage="Donation receipt"
          />,
        createFromDocumentItemsList: []
      };
    case T.PURCHASE_ORDER:
      return {
        icon: <img src={defaultDocument} alt="icon"/>,
        badgeColor: 'secondary',
        backgroundColor: 'bg-secondary',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-500"
            defaultMessage="Purchase order"
          />,
        createFromDocumentItemsList: []
      };
    case T.RECEIVING_DEPOSIT:
      return {
        icon: <img src={defaultDocument} alt="icon"/>,
        badgeColor: 'secondary',
        backgroundColor: 'bg-secondary',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-600"
            defaultMessage="Receiving a deposit"
          />,
        createFromDocumentItemsList: []
      };
    case T.WITHDRAWAL_DEPOSIT:
      return {
        icon: <img src={defaultDocument} alt="icon"/>,
        badgeColor: 'secondary',
        backgroundColor: 'bg-secondary',
        typeName:
          <FormattedMessage
            id="customer-details-documentInfo-value-type-610"
            defaultMessage="Deposit withdrawal"
          />,
        createFromDocumentItemsList: []
      };
    default:
      return {
        icon: <img src={defaultDocument} alt="icon"/>,
        badgeColor: 'secondary',
        backgroundColor: 'bg-secondary',
        typeName: '',
        createFromDocumentItemsList: []
      };
  }
};
